import { LoadStop } from '../models/jobs'
import { getFormattedDate } from './utils'

export function getLocalizedStopAppointmentWindow(stop: LoadStop) {
  const localizedDateStart = getFormattedDate(stop.date_start, stop.location_timezone)
  const localizedDateEnd = getFormattedDate(stop.date_end, stop.location_timezone)
  return localizedDateStart !== localizedDateEnd
    ? `${localizedDateStart} - ${localizedDateEnd}`
    : localizedDateStart
}
